const Layout = {
    taskViewPaddingLeft: 16,
    taskViewPaddingRight: 16,
    accordionWidth: window.innerWidth - (32),
    accordionHeaderHeight: 64,
    taskItemHeight: 56,
}
export default Layout